module.exports = __webpack_public_path__ + "img/more.c971cc2e.svg";